import { useDispatch } from 'react-redux';
import { setAppBusy } from 'store/actions/system';
import { Auth } from 'lib/Amplify';
import { setUser } from 'store/actions/user';
import useMessages from 'hooks/useMessages';

const defaultMessage = 'Thank you, you have successfully logged out.';

export default () => {
  const dispatch = useDispatch();
  const { genericInfoMessage } = useMessages();

  return (message = defaultMessage) => {
    dispatch(setAppBusy(true));
    Auth.signOut()
      .then(() => {
        genericInfoMessage(message);
        dispatch(setUser(null));
      })
      .finally(() => setAppBusy(false));
  };
};
